import { Settings } from 'lucide-react'
import { Link } from 'react-router'
import { cn } from '@/lib/utils'

// The way to a circle's settings (its name, spaces, what it has, keeping a copy, leaving): a cog on its Home.
export function SettingsCog({ familyId, className }: { familyId: string; className?: string }) {
  return (
    <Link
      to={`/circle/${familyId}/settings`}
      aria-label="Circle settings"
      title="Circle settings"
      className={cn(
        'grid size-10 shrink-0 place-items-center rounded-full text-muted-foreground outline-none hover:bg-secondary hover:text-foreground focus-visible:ring-[3px] focus-visible:ring-ring/50 pointer-coarse:size-11',
        className,
      )}
    >
      <Settings className="size-5" aria-hidden />
    </Link>
  )
}
